import React = require("react");
import { ready } from "../../../../custom_api/api_utils";
import { AdviceSortMethod, adviceSortMethods, AdviceType } from "../../../../custom_api/bookarang/types";
import { pushInspirationAction } from "../../datalayer";
import { Link } from "../../library/link";
import { Loader } from "../../loader";
import { Advice } from "./Advice";
import { Filters } from "./FilterSelector/FilterSelector";
import { sortLabels } from "./FilterSelector/FilterSelectorState";
import { InspirationBaseSelector, inspirationLabelsWeb } from "../Shared/InspirationBaseSelector";
import { InspirationWrapper } from "../Shared/InspirationWrapperWeb";
import { AdviceLayoutProps } from "./AdviceState";
import { AsyncState } from "widgets-for-react";
import { CollectionItem } from "../../../../../Shared/backendApi/generated";

export const AdviceLayoutWeb = (props: AdviceLayoutProps) => {
  const { collectionPage, adviceType, selectedPrompt, advice, filters, updateFilterValue, selectedBook, sortMethod, updateSortMethod, routePath } = props

  return (
    <div className="advice-page ip" key="AdviceLayout">
      {collectionPage.kind != "loaded" ? <Loader /> :
        <InspirationWrapper {...collectionPage.value}>
          <div className={"ip__content"}>
            <div className="container--m">
              <h2 className="ip__title title--l">Inspiratie nodig?</h2>
              <p className="ip_description description--l">
                Heb je hulp nodig met het ontdekken van je volgende boek? Kijk dan hieronder.
                Klik op een boek dat je leuk lijkt en reserveer het direct bij jouw bibliotheek.
              </p>
              <InspirationBaseSelector activeBase={adviceType} routePath={routePath} labels={inspirationLabelsWeb} />

              <div className={`layout layout--sc-ip container--m layout--${adviceType}`}>
                <div className="layout__top">
                  <div className="layout__header ip__header--tools">
                    <div className="layout__title">
                      {
                        adviceType == 'book' ?
                          <Link url={`/${routePath}/boek`} className="layout__header-link" title="Terug">
                            <svg className="layout__header-link-icon" width="8" height="21" aria-hidden="true"><use xlinkHref="#icon--chevron-right" /></svg>
                          </Link>
                          : adviceType == 'mood' ?
                            <Link url={`/${routePath}/stemming`} className="layout__header-link" title="Terug">
                              <svg className="layout__header-link-icon" width="8" height="21" aria-hidden="true"><use xlinkHref="#icon--chevron-right" /></svg>
                            </Link>
                            : adviceType == 'theme' ?
                              <Link url={`/${routePath}/thema`} className="layout__header-link" title="Terug">
                                <svg className="layout__header-link-icon" width="8" height="21" aria-hidden="true"><use xlinkHref="#icon--chevron-right" /></svg>
                              </Link>
                              : <></>
                      }
                      {advice.kind == 'loaded'
                        ? resultTextSection(adviceType, selectedPrompt, advice.value.length, selectedBook)
                        : 'Resultaten worden geladen...'
                      }
                    </div>

                    <div className="ip__tools">
                      <label htmlFor="form-select-filter" className="form__select-label">Sorteren op:</label>
                      <div className="ip__sort form__select">
                        <select id="form-select-filter" value={sortMethod} onChange={(e) => updateSortMethod(e.target.value as AdviceSortMethod)}>
                          {adviceSortMethods.map((method: AdviceSortMethod) => {
                            return <option key={`${method}_sort_method_option`} value={method}>{sortLabels[method]}</option>
                          })}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                {adviceType == 'book' ? <></> :
                  <div className="layout__sidebar">
                    {(ready(filters) && filters.value.length > 0) ?
                      <div className="ip__filter">
                        <div id="a11y-tbi-filter" className="ip__filter-content" aria-hidden="false">
                          <div className="ip__filter-inner">
                            <div className="layout__header ip__header--filter">
                              <h2 className="layout__title title--s">Verfijn resultaten</h2>
                            </div>
                            <Filters filters={filters.value} updateFilterValue={updateFilterValue} />
                          </div>
                        </div>
                      </div>
                      : <p>Er zijn geen filters gevonden voor <strong>{selectedPrompt}</strong>.</p>
                    }
                  </div>
                }

                <div className="layout__content">
                  {ready(advice) && <Advice
                    advice={advice.value}
                    state={advice.kind}
                    urlFrom={b => `https://probiblio.hostedwise.nl/wise-apps/catalog/6190/detail/wise/${b.id}`}
                    handlerFrom={b => () => pushInspirationAction(adviceType, "Klik naar Wise", `${b.title} - ${b.author}`)}
                  />}
                </div>
              </div>
            </div>
          </div>
        </InspirationWrapper>
      }
    </div>)
}

const resultTextSection = (adviceType: AdviceType, selectedPrompt: string, amount: number, selectedBook: AsyncState<CollectionItem>) => {
  if (adviceType == 'book' && selectedBook.kind == "loaded")
    return <div className="layout__header-content">
      <p>Je hebt <strong>{selectedBook.value.title}</strong> van <strong>{selectedBook.value.authors?.[0]}</strong> gekozen als startboek.</p>
      <p>Hieronder zie je {amount} boeken die erop lijken.</p>
    </div>
  if (adviceType == 'mood')
    return <span>Je hebt gekozen voor <strong>{selectedPrompt}</strong>. Filter om bij een boek te vinden dat bij je past.</span>
  if (adviceType == 'theme')
    return <span>Je hebt <strong>{selectedPrompt}</strong> als onderwerp gekozen. Filter om een boek te vinden dat bij je past.</span>
}
